package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.STAFF_FORGOT_PASSWORD
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class ForgotPasswordStaffRequestModel(
    val email: String
) : BaseRequestModel(api = STAFF_FORGOT_PASSWORD)
